// import { SplideSlide } from '@splidejs/react-splide'
// import { useParams } from 'react-router'
// import { Link } from 'react-router-dom'
// import { useSponsorTypesContext } from '../../context/sponsor-types/SponsorTypeProvider'
// import SilderSponsersBanners from '../../../core/components/SilderSponsersBanners'

// export default function SliderDiamondSponsorsBanners() {
//   const { lng } = useParams()
//   const { sponsorTypesState } = useSponsorTypesContext()

//   if (sponsorTypesState.isLoading) {
//     return (
//       <div
//         data-aos="fade-up"
//         className="app-container"
//       >
//         <div className="h-[276px] animate-pulse bg-muted-400"></div>
//       </div>
//     )
//   }

//   if (sponsorTypesState.types.diamond?.have_sponsors)
//     return (
//       <SilderSponsersBanners>
//         {sponsorTypesState.types.diamond?.sponsors.map((sponsor) => (
//           <SplideSlide key={sponsor.id}>
//             <Link
//               to={`/${lng}/sponsors/${sponsor.slug}`}
//               className="flex flex-col items-start justify-start"
//             >
//               <div
//                 title={sponsorTypesState.types.diamond[`name_${lng}`]}
//                 className="max-h-[276px] overflow-hidden border-2 border-info bg-muted-300"
//               >
//                 <img
//                   src={`${process.env.REACT_APP_API_BASE_URL}/storage/${sponsor.banner}`}
//                   alt={sponsor[`name_${lng}`]}
//                   className="h-full w-full object-contain"
//                 />
//               </div>
//             </Link>
//           </SplideSlide>
//         ))}
//       </SilderSponsersBanners>
//     )
// }





import { SplideSlide } from '@splidejs/react-splide';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { useSponsorTypesContext } from '../../context/sponsor-types/SponsorTypeProvider';
import SilderSponsersBanners from '../../../core/components/SilderSponsersBanners';

export default function SliderDiamondSponsorsBanners() {
  const { lng } = useParams();
  const { sponsorTypesState } = useSponsorTypesContext();

  // Loading state
  if (sponsorTypesState.isLoading) {
    return (
      <div data-aos="fade-up" className="app-container">
        <div className="h-[276px] animate-pulse bg-muted-400"></div>
      </div>
    );
  }

  // Extraction sécurisée
  const types = sponsorTypesState.types;
  const diamond = types?.diamond;

  // Si aucun sponsor ou diamond null → ne rien afficher
  if (!diamond?.have_sponsors || !diamond.sponsors?.length) {
    return null; // ou un message : <p>Aucun sponsor</p>
  }

  return (
    <SilderSponsersBanners>
      {diamond.sponsors.map((sponsor) => (
        <SplideSlide key={sponsor.id}>
          <Link
            to={`/${lng}/sponsors/${sponsor.slug}`}
            className="flex flex-col items-start justify-start"
          >
            <div
              title={diamond[`name_${lng}`]}
              className="max-h-[276px] overflow-hidden border-2 border-info bg-muted-300"
            >
              <img
                src={`${process.env.REACT_APP_API_BASE_URL}/storage/${sponsor.banner}`}
                alt={sponsor[`name_${lng}`]}
                className="h-full w-full object-contain"
              />
            </div>
          </Link>
        </SplideSlide>
      ))}
    </SilderSponsersBanners>
  );
}